import React, {Suspense} from "react";
import ReactDOM from "react-dom";
import "./styles/style.scss";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  Navigation,
  Footer,
  Home,
  UeberUns,
  Beispiele,
  Rezensionen,
  Kontakt,
  Impressum
} from "./components";
import {I18nextProvider} from "react-i18next";
import i18next from "i18next";

// import i18n (needs to be bundled ;))
import './i18n';


ReactDOM.render(
  <Suspense fallback="loading">
  <Router>
    <I18nextProvider i18n={i18next}>
    <Navigation />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/ueber_uns" element={<UeberUns />} />
      <Route path="/beispiele" element={<Beispiele />}/>
      <Route path="/rezensionen" element={<Rezensionen />}/>
      <Route path="/kontakt" element={<Kontakt />} />
      <Route path="/impressum_datenschutz" element={<Impressum />} />
    </Routes>
    <Footer />
    </I18nextProvider>
  </Router>
  </Suspense>,

  document.getElementById("root")
);

serviceWorker.unregister();